import http from '@/utils/http-provider';

const fiflboxApi = {
  default: {
    setHeadersAuthorization(token) {
      http.defaults.headers.common['Authorization'] = token;
    },
    deleteHeadersAuthorization() {
      delete http.defaults.headers.common['Authorization'];
    }
  },
  v1: {
    // GET
    getAccountsCenter() {
      return http.get('/v1/accounts/center/');
    },
    getFiflboxNotice() {
      return http.get('/v1/admin/fiflbox/notices/');
    },
    getCenterNotice() {
      return http.get('/v1/admin/center/notices/');
    },
    getCenterInstructors() {
      return http.get('/v1/admin/center/instructors/');
    },
    getPaymentHistories() {
      return http.get('/v1/admin/center/payment/histories/');
    },
    getCourseCategories() {
      return http.get('/v1/admin/course/categories/');
    },
    getWodsById(id) {
      return http.get(`/v1/admin/wods/${id}/`);
    },
    getFiflboxNoticeById(id) {
      return http.get(`/v1/admin/fiflbox/notices/${id}/`);
    },
    getCenterNoticeById(id) {
      return http.get(`/v1/admin/center/notices/${id}/`);
    },
    getEnrollmentMemberById(id) {
      return http.get(`/v1/admin/enrollment/members/${id}/`);
    },
    getWods(params) {
      return http.get('/v1/admin/wods/', { params });
    },
    getChildCourses(params) {
      return http.get('/v1/admin/course/child-courses/', { params });
    },
    getParentCourses(params) {
      return http.get('/v1/admin/course/parent-courses/', { params });
    },
    getDashBoardCourses(params) {
      return http.get('/v1/admin/dashboard/courses/', { params });
    },
    getDashBoardMembers(params) {
      return http.get('/v1/admin/dashboard/members/', { params });
    },
    getLockerRooms(params) {
      return http.get('/v1/admin/locker/rooms/', { params });
    },
    getLockerHistories(params) {
      return http.get('/v1/admin/locker/histories/', { params });
    },
    getEnrollmentMembers(params) {
      return http.get('/v1/admin/enrollment/members/', { params });
    },
    getBookings(params) {
      return http.get('/v1/admin/booking/bookings/', { params });
    },
    getBookingBlockings(params) {
      return http.get('/v1/admin/booking/blockings/', { params });
    },
    getBookingHistories(params) {
      return http.get('/v1/admin/booking/histories/', { params });
    },
    getChildMemberships(params) {
      return http.get('/v1/admin/membership/child-memberships/', { params });
    },
    getReferralDashboardInfos(params) {
      return http.get('/v1/referral/dashboard/', params);
    },
    getBookingsOutOfRange(params) {
      return http.get('/v1/admin/booking/checkchildmembership/', { params });
    },
    getCheckBookingInBookedList(params) {
      return http.get('/v1/admin/booking/checkchildcourse/', { params });
    },
    // PUT
    putBookings(id, payload) {
      return http.put(`/v1/admin/booking/bookings/${id}/`, payload);
    },
    putBookingBlockings(id, payload) {
      return http.put(`/v1/admin/booking/blockings/${id}/`, payload);
    },
    putBookingAttendances(id, payload) {
      return http.put(`/v1/admin/booking/attendances/${id}/`, payload);
    },
    putCourseCategories(id, payload) {
      return http.put(`/v1/admin/course/categories/${id}/`, payload);
    },
    putCenterInstructors(id, payload) {
      return http.put(`/v1/admin/center/instructors/${id}/`, payload);
    },
    putParentCourses(id, payload) {
      return http.put(`/v1/admin/course/parent-courses/${id}/`, payload);
    },
    putChildCourses(id, payload) {
      return http.put(`/v1/admin/course/child-courses/${id}/`, payload);
    },
    putEnrollmentMembers(id, payload) {
      return http.put(`/v1/admin/enrollment/members/${id}/`, payload);
    },
    putLockerHistories(id, payload) {
      return http.put(`/v1/admin/locker/histories/${id}/`, payload);
    },
    putCenterNotices(id, payload) {
      return http.put(`/v1/admin/center/notices/${id}/`, payload);
    },
    putWods(id, payload) {
      return http.put(`/v1/admin/wods/${id}/`, payload);
    },
    // POST
    postAccountsLogout() {
      return http.post('/v1/accounts/logout/');
    },
    postCourseExclusions(payload) {
      return http.post('/v1/admin/course/exclusions/', payload);
    },
    postLockerRooms(payload) {
      return http.post('/v1/admin/locker/rooms/', payload);
    },
    postLockerHistories(payload) {
      return http.post('/v1/admin/locker/histories/', payload);
    },
    postCourseCategoriesc(payload) {
      return http.post('/v1/admin/course/categories/', payload);
    },
    postCenterInstructors(payload) {
      return http.post('/v1/admin/center/instructors/', payload);
    },
    postChildCourses(payload) {
      return http.post('/v1/admin/course/child-courses/', payload);
    },
    postParentCourses(payload) {
      return http.post('/v1/admin/course/parent-courses/', payload);
    },
    postCenterNotices(payload) {
      return http.post('/v1/admin/center/notices/', payload);
    },
    postBookings(payload) {
      return http.post('/v1/admin/booking/bookings/', payload);
    },
    postBookingBlockings(payload) {
      return http.post('/v1/admin/booking/blockings/', payload);
    },
    postBookingAttendances(payload) {
      return http.post('/v1/admin/booking/attendances/', payload);
    },
    postWods(payload) {
      return http.post('/v1/admin/wods/', payload);
    },
    postAccountsLogin(payload, options) {
      return http.post('/v1/accounts/login/', payload, options);
    },
    postCenterImages(payload, options) {
      return http.post('/v1/admin/center/images/', payload, options);
    },
    postCheckEmail(payload) {
      return http.post('/v1/accounts/check/email/', payload);
    },
    postCheckInstructorEmail(payload) {
      return http.post('/v1/accounts/check/instructor/email/', payload);
    },
    postCheckCenterName(payload) {
      return http.post('/v1/accounts/check/center-name/', payload);
    },
    postReferralInviteMail(payload) {
      return http.post('/v1/referral/invite/', payload);
    },
    // PATCH
    patchLockerRooms(id, payload) {
      return http.patch(`/v1/admin/locker/rooms/${id}/`, payload);
    },
    patchEnrollmentMembers(id, payload) {
      return http.patch(`/v1/admin/enrollment/members/${id}/`, payload);
    },
    patchBulkBookingStatus(payload) {
      return http.patch('/v1/admin/booking/bulk/', payload);
    },
    // DELETE
    deleteChildCourses(id) {
      return http.delete(`/v1/admin/course/child-courses/${id}/`);
    },
    deleteParentCourses(id) {
      return http.delete(`/v1/admin/course/parent-courses/${id}/`);
    },
    deleteParentMemberships(id) {
      return http.delete(`/v1/admin/membership/parent-memberships/${id}/`);
    },
    deleteEnrollmentMembers(id) {
      return http.delete(`/v1/admin/enrollment/members/${id}/`);
    },
    deleteLockerHistories(id) {
      return http.delete(`/v1/admin/locker/histories/${id}/`);
    },
    deleteCenterNotices(id) {
      return http.delete(`/v1/admin/center/notices/${id}/`);
    },
    deleteWods(id) {
      return http.delete(`/v1/admin/wods/${id}/`);
    },
    deleteCenterInstructors(id, payload) {
      return http.delete(`/v1/admin/center/instructors/${id}/`, payload);
    },
    deleteCourseCategories(id, payload) {
      return http.delete(`/v1/admin/course/categories/${id}/`, payload);
    },
    deleteBookingBlockings(id, payload) {
      return http.delete(`/v1/admin/booking/blockings/${id}/`, payload);
    }
  },
  v2: {
    // GET
    getProfile() {
      return http.get('/v2/admin/profile/');
    },
    getPolicy() {
      return http.get('/v2/admin/policy/');
    },
    getParentMemberships() {
      return http.get('/v2/admin/parent-memberships/');
    },
    getMembershipCategories(params) {
      return http.get('/v2/admin/membership/categories/', { params });
    },
    getParentMembershipsById(id) {
      return http.get(`/v2/admin/parent-memberships/${id}/`);
    },
    getCenterInstructors() {
      return http.get('/v2/admin/center/instructors/');
    },
    getChildMembershipsById(id) {
      return http.get(`/v2/admin/child-memberships/${id}/`);
    },
    getChildMemberships(params) {
      return http.get('/v2/admin/child-memberships/', { params });
    },
    getChildCourses(params) {
      return http.get('/v2/admin/course/child-courses/', { params });
    },
    getRegisters(params) {
      return http.get('/v2/admin/registers/', { params });
    },
    getMembershipPayments(params) {
      return http.get('/v2/admin/membership/payments/', { params });
    },
    getCenterNameByCode(params) {
      return http.get('/v2/admin/center/name/', { params });
    },
    getInstructorRoles() {
      return http.get('/v2/admin/instructor/role/');
    },
    getInstructorAccessAuthById(id) {
      return http.get(`/v2/admin/instructor/access/auth/${id}/`);
    },
    getInstructorAccessAuthByToken(params) {
      return http.get('/v2/admin/instructor/access/auth/', { params });
    },
    getCourseCategories(params) {
      return http.get('/v2/admin/course/categories/', { params });
    },
    // PUT
    putProfile(payload) {
      return http.put('/v2/admin/profile/', payload);
    },
    putPolicy(payload) {
      return http.put('/v2/admin/policy/', payload);
    },
    putCenterInstructors(id, payload) {
      return http.put(`/v2/admin/center/instructors/${id}/`, payload);
    },
    putChildMemberships(id, payload) {
      return http.put(`/v2/admin/child-memberships/${id}/`, payload);
    },
    putChildCourses(id, payload) {
      return http.put(`/v2/admin/course/child-courses/${id}/`, payload);
    },
    putParentMemberships(id, payload) {
      return http.put(`/v2/admin/parent-memberships/${id}/`, payload);
    },
    putMembershipCategories(id, payload) {
      return http.put(`/v2/admin/membership/categories/${id}/`, payload);
    },
    putMembershipHoldings(id, payload) {
      return http.put(`/v2/admin/membership/holdings/${id}/`, payload);
    },
    putInstructorAccessAuth(id, payload) {
      return http.put(`/v2/admin/instructor/access/auth/${id}/`, payload);
    },
    putMembershipPayments(id, payload) {
      return http.put(`/v2/admin/membership/payments/${id}/`, payload);
    },
    // POST
    postSignup(payload) {
      return http.post('/v2/admin/signup/', payload);
    },
    postPasswordChange(payload) {
      return http.post('/v2/account/password/change/', payload);
    },
    postPasswordReset(payload) {
      return http.post('/v2/account/password/reset/', payload);
    },
    postPasswordResetConfirm(payload) {
      return http.post('/v2/account/password/reset/confirm/', payload);
    },
    postChildMemberships(payload) {
      return http.post('/v2/admin/child-memberships/', payload);
    },
    postChildCourses(payload) {
      return http.post('/v2/admin/course/child-courses/', payload);
    },
    postCenterInstructors(payload) {
      return http.post('/v2/admin/center/instructors/', payload);
    },
    postParentMemberships(payload) {
      return http.post('/v2/admin/parent-memberships/', payload);
    },
    postMembers(payload) {
      return http.post('/v2/admin/members/', payload);
    },
    postMembershipCategories(payload) {
      return http.post('/v2/admin/membership/categories/', payload);
    },
    postMembershipHoldings(payload) {
      return http.post('/v2/admin/membership/holdings/', payload);
    },
    postLogin(payload, options) {
      return http.post('/v2/admin/login/', payload, options);
    },
    postAccountImages(payload, options) {
      return http.post('/v2/account/images/', payload, options);
    },
    postMailChimpSubscribe(payload) {
      return http.post('/v2/account/mailchimp/subscriber/', payload);
    },
    // DELETE
    deleteMembershipCategories(id) {
      return http.delete(`/v2/admin/membership/categories/${id}/`);
    },
    deleteChildMemberships(id) {
      return http.delete(`/v2/admin/child-memberships/${id}/`);
    },
    deleteChildCourses(id) {
      return http.delete(`/v2/admin/course/child-courses/${id}/`);
    },
    deleteMembershipHoldings(id) {
      return http.delete(`/v2/admin/membership/holdings/${id}/`);
    }
  }
};

export { fiflboxApi };
